import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

// Affirm and Klarna hydrate their own markup once their SDK is ready. The
// section morph re-renders that markup on every variant change, so both need
// an explicit refresh to pick up the new amount.
if (!customElements.get('payment-messaging')) {
  class PaymentMessaging extends Component {
    #abortController;

    connectedCallback() {
      super.connectedCallback();

      this.#abortController = new AbortController();
      document.addEventListener(ThemeEvents.variantUpdate, this.#refresh, {
        signal: this.#abortController.signal,
      });

      this.#refresh();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      super.disconnectedCallback();
    }

    // The SDKs are injected by their apps, so both may be missing entirely.
    #refresh = () => {
      window.affirm?.ui?.ready(() => window.affirm.ui.refresh());
      window.Klarna?.OnsiteMessaging?.refresh();
    };
  }

  customElements.define('payment-messaging', PaymentMessaging);
}
